import commonHelper from '@/app/utility/common.helper.utility';

export default {
  name: 'assetStatus',
  props: ['rowData'],
  components:{
},
  watch: {
    currentPage: function() {
        this.getSummaryData();
    },
    perPage: function() {
      this.currentPage = 1;
      this.getSummaryData();
    },
  },
  data() {
    return {
      totalRows: null,
      currentPage: 1,
      loader: false,
      responseMsg: '',
      isSuccess: false,
      showAlert: false,
      perPage: commonHelper.perPageRecord,
      pageOptions: commonHelper.getPageOptionSelectedInvoice(),
      summaryData:[
      ],
      summaryFields:[
        {
          key:'batch_num',
          label: 'Batch No.'
        },
        {
          key:'book_type_code',
          label: 'Book Type'
        },
        {
          key:'invoice_number',
          label: 'Invoice No.'
        },
        {
          key:'location_from'
        },
        {
          key:'location_to',
        },
        {
          key:'waybill',
        },
        {
          key:'gross_book_value'
        },
        {
          key:'creation_date'
        }
      ],
      countData: null,
      additionalModal: false,
    };
  },
  mounted() {
    this.getSummaryData()
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'save') {
          //   this.showHideAddFaLocationModal(true);
        } else if (actionName === 'edit' || actionName === 'update' && (!this.showAssetDetailsModalFlag || !this.showDashDetailFlag)) {
          this.editMode = true;
        }
        else if (
          actionName === 'download' && !this.showAssetDetailsModalFlag
        ) {
            this.loader = true;
            const downloadpayload = { ...this.payload };
            downloadpayload.queryParams._limit = this.totalRows;
            this.downloadExcel.downloadData(
              downloadpayload,
              'assets/getDashboardAssetStatusDetails',
              'fa-getAssetDetails',
              () => (this.loader = false),
            );
        }
      }
    });
  },
  methods: {
    getSummaryData() {
    this.payload = {
      _page: this.currentPage - 1,
      _limit: this.perPage,
      asset_id: this.rowData.asset_id,
    };
    this.loader = true;
    this.$store
      .dispatch('weighMachine/getSummaryData', this.payload)
      .then(resp => {
        this.loader = false;
        if (resp.status === 200) {
          this.summaryData = resp.data.data.page;
          this.totalRows = resp.data.data.total_elements;
        }
      })
      .catch(() => {
        this.loader = false;
      });
  }
  },
  beforeDestroy() {
    this.unsubscribe();
  }
};
